export const assertNotNull = <TValue>(value: TValue | null | undefined): TValue => {
  if (value == null) {
    throw new Error(`Asserted that value was not null, but it was ${value}`);
  }

  return value;
};
